class CustomScripts {
    static async checkoutWithAdditionalChecks() {
        //disabilita il bottone
        const ok = await CustomScripts.checkCartAvailability();
        return ok;
  
    }
    static checkThenCheckout(element = null){
        let orig = ''
        if(element){
            orig = element.innerText;
            element.innerText = element.dataset.loadingtext;
            element.disabled = true;
        }
        CustomScripts.checkoutWithAdditionalChecks().then(ok => {
            window.location = `${window.Shopify.routes.root}checkout`;
        });
        if(element){
            element.disabled = false;
            element.innerText = orig;
        }
    }
  
    static async updateCartLinesWithDeliveryDate(deliveryDateString) {
        const cartRes = await fetch('/cart.js', { credentials: 'same-origin' });
        if (!cartRes.ok) throw new Error('Impossibile recuperare il carrello');
        const currentCart = await cartRes.json();
  
        // Crea l'array di promesse per aggiornare ogni articolo del carrello
        const updatePromises = currentCart.items.map(item => {
            return fetch('/cart/change.js', {
                method: 'POST',
                credentials: 'same-origin',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    id: item.key,
                    quantity: item.quantity,
                    properties: {
                        'consegna_il': deliveryDateString
                    }
                })
            }).then(res => {
                if (!res.ok) throw new Error('Errore aggiornamento riga ' + item.key);
                return res.json();
            });
        });
  
        // Invia tutte le richieste
        return Promise.all(updatePromises);
  
    }
  
    static async checkCartAvailability() {
        try {
            // carrello aggiornato dal server
            const cartRes = await fetch('/cart.js', { credentials: 'same-origin' });
            if (!cartRes.ok) throw new Error('Impossibile recuperare il carrello');
            const currentCart = await cartRes.json();
  
            if (!currentCart.items || currentCart.items.length === 0) {
                return true; // carrello vuoto => nulla da controllare
            }
  
            // costruisci array di GID variante aggiornato
            const variantGids = currentCart.items.map(item => `gid://shopify/ProductVariant/${item.variant_id}`);
  
            // chiama l'endpoint di availability (con slash iniziale)
            const availRes = await fetch('/apps/connector/cart/lines/availability', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(variantGids)
            });
  
            if (!availRes.ok) throw new Error('Errore nella chiamata di availability');
            const data = await availRes.json();
  
            if (!data.isSuccessful) {
                document.getElementById('result-aviability-check').innerText = data.message || 'Errore controllo disponibilità';
                return false;
            }
  
  
  
            // confronta disponibilità con quantità nel carrello corrente
            const unavailableVariants = (data.variants || []).filter(v => {
                if (v.locations === null) return true;
                const vid = parseInt(String(v.variantId).split('/').pop(), 10);
                const cartItem = currentCart.items.find(it => it.variant_id === vid);
                if (!cartItem) return true;
                const totalAvailable = v.locations.reduce((s, loc) => s + (loc.available || 0), 0);
                return totalAvailable < cartItem.quantity;
            });
  
            if (unavailableVariants.length > 0) {
                let message = 'I seguenti prodotti non sono disponibili nelle quantità desiderate:\n';
                unavailableVariants.forEach(v => {
                    const vid = parseInt(String(v.variantId).split('/').pop(), 10);
                    const cartItem = currentCart.items.find(it => it.variant_id === vid) || {};
                    const available = v.locations ? v.locations.reduce((s, loc) => s + (loc.available || 0), 0) : 0;
                    message += `- ${cartItem.product_title || 'Prodotto'} (Richiesto: ${cartItem.quantity || 0}, Disponibile: ${available})\n`;
                });
                document.getElementById('result-aviability-check').innerText = message;
                return false;
            }else{
                // Calcola il tempo di consegna
                let maxDeliveryTime = 0;
                (data.variants || []).forEach(v => {
                    const minDeliveryTime = Math.min(...v.locations.filter(loc => loc.available > 0).map(loc => loc.deliveryTime || 1));
                    if (minDeliveryTime > maxDeliveryTime) {
                        maxDeliveryTime = minDeliveryTime;
                    }
                });
  
                //const deliveryDate = new Date();
                //deliveryDate.setDate(deliveryDate.getDate() + maxDeliveryTime);
                //const deliveryDateString = deliveryDate.toISOString().split('T')[0];
                //const [year, month, day] = deliveryDateString.split('-');
                //const formattedDeliveryDate = `${day}/${month}/${year}`;
                  // Aggiorna le righe del carrello con la data di consegna
  
  
                // Aggiorna gli attributi del carrello con la data di consegna
                await fetch('/cart/update.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        attributes: {
                            'consegna_il': maxDeliveryTime
                        }
                    })
                });
                /*
                try {
                    await updateCartLinesWithDeliveryDate(formattedDeliveryDate);
                    //alert(`Il tempo di consegna stimato è di ${maxDeliveryTime} giorni. Consegna prevista il ${deliveryDateString}.`);
                } catch (err) {
                    console.error('Errore durante l\'aggiornamento delle righe del carrello:', err);
                    document.getElementById('result-aviability-check').innerText = 'Errore durante l\'aggiornamento del carrello';
                    return false;
                }*/
  
  
  
                //alert(`Il tempo di consegna stimato è di ${maxDeliveryTime} giorni. Consegna prevista il ${deliveryDateString}.`);
                console.log(`Consegna prevista il ${maxDeliveryTime}.`);
  
  
            }
  
            // tutto ok
            return true;
        } catch (err) {
            console.error('checkCartAvailability error:', err);
            return false;
        }
    }
}
/* ------------------------------------------------------------------------
 * Banner PayPal Pay Later — posizione nella scheda prodotto
 * Richiesta: docs/requests/2026-08-18-posizione-banner-paypal-pay-later.md
 *
 * L'app embed "PayPal Pay Later Embed" e' configurata (campo Product Page)
 * per agganciarsi a div.product__price--holder.product__price--ppPrice e
 * inietta #paypal-upstream-messaging-product subito dopo il blocco prezzo.
 * Lo script di Scalapay parte dopo, punta allo stesso contenitore e si
 * infila nello stesso punto, finendo SOPRA il messaggio PayPal.
 *
 * I due nodi sono fratelli dentro il <form> della colonna info, che e'
 * display:block (.unflex): 'order' non e' applicabile, il riordino via CSS
 * richiederebbe di rendere flex tutto il form. Si sposta quindi il nodo.
 *
 * No-op se uno dei due manca: PayPal ha soglie di importo proprie, Scalapay
 * ha min_amount/max_amount, e su molti prodotti compare uno solo dei due.
 * ------------------------------------------------------------------------ */
(function () {
  var SEL_PAYPAL = '#paypal-upstream-messaging-product';
  var SEL_SCALAPAY = 'scalapay-widget';

  // Sposta PayPal prima di Scalapay. true = fatto (o gia' in ordine).
  function ordinaBanner() {
    var paypal = document.querySelector(SEL_PAYPAL);
    var scalapay = document.querySelector(SEL_SCALAPAY);
    if (!paypal || !scalapay) return false;

    // Struttura inattesa (una delle app ha cambiato punto di iniezione):
    // meglio lasciare la pagina come sta che spostare nodi a caso.
    if (paypal.parentElement !== scalapay.parentElement) return false;

    if (paypal.nextElementSibling !== scalapay) {
      scalapay.parentElement.insertBefore(paypal, scalapay);
    }
    return true;
  }

  // Fase 2: dopo il primo riordino si resta in ascolto sul solo contenitore
  // condiviso, senza subtree. Serve perche' Scalapay si re-renderizza al
  // cambio variante e puo' re-inserirsi davanti a PayPal.
  function presidia(contenitore) {
    new MutationObserver(ordinaBanner).observe(contenitore, { childList: true });
  }

  // Fase 1: i due nodi arrivano in momenti diversi e non prevedibili.
  if (ordinaBanner()) {
    presidia(document.querySelector(SEL_PAYPAL).parentElement);
    return;
  }

  var attesa = new MutationObserver(function () {
    if (!ordinaBanner()) return;
    attesa.disconnect();
    presidia(document.querySelector(SEL_PAYPAL).parentElement);
  });
  attesa.observe(document.body, { childList: true, subtree: true });

  // Se una delle due app non renderizza, si smette di osservare l'intero body.
  setTimeout(function () { attesa.disconnect(); }, 15000);
})();
